import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_SIGNATURE_GROWTH_PSF_FB_SHARE_HEADLINES = createFcmDetails(
	'signature_growth_psf_fb_share_headlines',
	{
		owner: 'Signature Growth',
		context: 'PSF',
		description: `
    Select a different title and description when sharing via Facebook in the PSF.
    `,
		import: false,
		template: {
			isEnabled: false,
			experimentName: '',
			variants: {
				fake_control: { title: '', description: '' },
				variant1: { title: '', description: '' },
				variant2: { title: '', description: '' },
				variant3: { title: '', description: '' },
				variant4: { title: '', description: '' },
			},
		},
	},
);
